angular.module('impactx.rfx').controller('RFXAddSupplierCtrl', RFXAddSupplierCtrl);

RFXAddSupplierCtrl.$inject = ['$scope', 'dataGen', 'TranslationService','ToastService', '$mdDialog', 'RFXBuyerService', '$mdPanel', 'AutocompleteSelectionPanel', '$redirect', 'rfqhId'];

function RFXAddSupplierCtrl($scope, dataGen, TranslationService, ToastService, $mdDialog, RFXBuyerService, $mdPanel, AutocompleteSelectionPanel, $redirect, rfqhId) {

    var self = this;

    $scope.abortLabel = TranslationService.get("abort");
    $scope.acceptLabel = TranslationService.get("save");
    $scope.forwarLabel = TranslationService.get("forward");

    $scope.wizardIndex = 0;
    
    function getData() {
        dataGen.getData($scope, {rfqhId: rfqhId}, "/rfx/buyer/addSupplier").then(function () {
            if (!impactX.isDefined($scope, 'data.message')) {
                $scope.wizardIndex = 1;
            }
        });
    };

    self.apply = function () {
        dataGen.postAsForm({}, {formData: $scope.data}, '/rfx/buyer/saveNewSuppliers').then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            $redirect.redirectTo(null, '/rfxbuyerlist');
            $mdDialog.hide();
        });
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.next = function () {
        $scope.wizardIndex = $scope.wizardIndex + 1;
    };

    self.openSupplierSelection = function (event) {
        var config = {
            uri: "/rfx/buyer/supplier",
            parameters: {
                rfqcId: $scope.data.rfqcId
            },
            selected: $scope.data.relatedSuppliers,
            event: event,
            xPosition: $mdPanel.xPosition.ALIGN_END,
            yPosition: $mdPanel.yPosition.BELOW
        };
        AutocompleteSelectionPanel.openPanel(config).then(function (selection) {
            $scope.dialogData.$setDirty();
            $scope.data.relatedSuppliers.push(selection);
        });
    };

    self.deleteSupplier = function (supplier) {
        var index = $scope.data.relatedSuppliers.indexOf(supplier);
        if (index >= 0) {
            $scope.data.relatedSuppliers.splice(index, 1);
        }
        $scope.dialogData.$setDirty();
    };

    getData();
}